import { Link } from "react-router-dom";
import { cx } from "../../../utils/classNames";
import ui from "../../../components/ui/ui.module.css";
import styles from "../Dashboard.module.css";

// { pending, approvedThisPeriod } from the dashboard.
const OvertimeCard = ({ overtime }) => (
  <>
    <div className={styles.stats}>
      <Link to="/me/overtime" className={cx(styles.stat, styles.statLink)}>
        <div className={styles.statValue}>{overtime.pending}</div>
        <div className={styles.statLabel}>Waiting for approval</div>
      </Link>
      <Link to="/me/overtime" className={cx(styles.stat, styles.statLink)}>
        <div className={styles.statValue}>{overtime.approvedThisPeriod}</div>
        <div className={styles.statLabel}>Approved this cut-off</div>
      </Link>
    </div>

    <div className={cx(styles.rowBetween, "mt-3")}>
      <Link to="/me/overtime" className={ui.linkButton}>
        My overtime <i className="bi bi-arrow-right"></i>
      </Link>
      <Link
        to="/me/overtime?file=1"
        className={cx(ui.button, ui.primary, ui.buttonSmall)}
      >
        <i className="bi bi-plus-lg"></i>
        File overtime
      </Link>
    </div>
  </>
);

export default OvertimeCard;
